import { useEffect, useRef, useState } from 'react'
import { WifiOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/utils/cn'
import { useToastStore } from '@/store/toast'

export function NetworkStatusBanner() {
  const { t } = useTranslation('modules')
  const [offline, setOffline] = useState(!navigator.onLine)
  const wasOffline = useRef(!navigator.onLine)
  const showToast = useToastStore((s) => s.show)

  useEffect(() => {
    const handleOffline = () => {
      setOffline(true)
      wasOffline.current = true
    }

    const handleOnline = () => {
      setOffline(false)
      if (wasOffline.current) {
        // No sound — recovery notification, not an alert
        showToast(t('network.backOnline'), 'success', 4000)
        wasOffline.current = false
      }
    }

    window.addEventListener('offline', handleOffline)
    window.addEventListener('online', handleOnline)
    return () => {
      window.removeEventListener('offline', handleOffline)
      window.removeEventListener('online', handleOnline)
    }
  }, [showToast, t])

  if (!offline) return null

  return (
    <div
      role="alert"
      aria-live="assertive"
      className={cn(
        'fixed top-0 inset-x-0 z-[10000]',
        'flex items-center justify-center gap-2.5',
        'bg-red-600 px-4 py-2.5',
        'animate-in slide-in-from-top-2 duration-300',
      )}
    >
      <WifiOff className="h-4 w-4 shrink-0 text-white" />
      <span className="text-sm font-semibold text-white">
        {t('network.offline')}
      </span>
      <span className="hidden text-sm text-red-200 sm:inline">
        — {t('network.offlineSubtitle')}
      </span>
    </div>
  )
}
